module.exports = __webpack_public_path__ + "media/KikiDylan.1690132b.mp3";